import React, { Component } from 'react';
import { Jumbotron, Container, Row } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { Button, Input } from 'reactstrap';
import { GET_MESSAGES_BY_BOX, GET_RANDOM_MESSAGES } from '../../query/query';
import Message from './message';

class ManagerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boxId: '9d7LTJ28fc5SVRY57o',
      error: false,
      messagesDeprecated: [],
      messages: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getRandomMessages = this.getRandomMessages.bind(this);
  }

  handleChange(event) {
    this.setState({ boxId: event.target.value });
  }

  handleSubmit(event) {
    console.log('A name was submitted: ' + this.state.boxId);
    event.preventDefault();
    this.getMessagesByBox(this.state.boxId);
  }

  getMessagesByBox(boxId) {
    this.props.client.query({
      query: GET_MESSAGES_BY_BOX,
      variables: {
        boxId,
      },
    }).then(({ data }) => {
      if (data.savManagerGetMessagesByBox) {
        this.setState({
          messagesDeprecated: data.savManagerGetMessagesByBox,
        });
      } else {
        this.setState({
          error: true,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  getRandomMessages() {
    this.props.client.query({
      query: GET_RANDOM_MESSAGES,
      variables: { limit: 100 },
      fetchPolicy: 'network-only',
    }).then(({ data }) => {
      if (data.savGetRandomAnonymizedMessages) {
        this.setState({
          messages: data.savGetRandomAnonymizedMessages,
        });
      } else {
        this.setState({
          error: true,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  componentWillMount() {
  }

  render() {
    return (
      <Jumbotron>
        <Container>
          <form onSubmit={this.handleSubmit}>
            <label>
              Box token:
              <Input type="text" value={this.state.boxId} onChange={this.handleChange} />
            </label>
            <Button style={{ marginLeft: '10px' }} type="submit">
              OK
            </Button>
          </form>
        </Container>
        <Container>
          {this.state.error ? 'Error' : ''}
          {this.state.messagesDeprecated.length > 0 ? <h6>Messages</h6> : ''}
          {
            this.state.messagesDeprecated.map(m => <Message key={m._id} message={m} />)
          }
        </Container>
        <Container>
          <Row>
            <Button onClick={this.getRandomMessages} style={{ marginLeft: '10px' }} color="success">
              Analyse random messages
            </Button>
          </Row>
          <Row style={{ flexDirection: 'row' }}>
            {
              this.state.messages.map(({ _id, url = '' } = {}) => (
                <img alt="message" key={_id} src={url} style={{ height: 240, width: 320 }} />
              ))
            }
          </Row>
        </Container>
      </Jumbotron>
    );
  }
}

export default withApollo(ManagerPage);



// WEBPACK FOOTER //
// ./src/components/manager/manager.js